import type { ReactNode } from "react";
import { Icon } from "@jsq/ds/icons";
import type { FieldDataType } from "~/graphql/supergraphTypes";

export { fieldDataTypeTag } from "./fieldDataTypeDisplay_vanilla.css";

export const getFieldDataTypeTagContent = (
  fieldType: FieldDataType | null | undefined,
): ReactNode => {
  switch (fieldType) {
    case "TEXT":
      return "Tt";
    case "DATE":
      return <Icon type="calendar" size="small" />;
    case "QUANTITY":
      return "#";
    case "VALUE":
      return "$";
    case "PERCENTAGE":
      return "%";
    default:
      return null;
  }
};
